export default "__VITE_ASSET__BdPNALk6__"